import React from 'react';

import Callout, { CALLOUT_TYPES } from 'js/src/components/common/ui/Callout';

interface SystemAudioMissingWarningProps {
    show: boolean;
}

const SystemAudioMissingWarning: React.FC<SystemAudioMissingWarningProps> = ({ show }) => {
    if (!show) {
        return null;
    }

    return (
        <Callout
            className="mb-l5-0"
            msgType={CALLOUT_TYPES.ALERT}
            text="System audio wasn't captured for this recording. To include it, retake and enable the system audio toggle in both Lumen5 and in the browser's screen-share dialog."
        />
    );
};

export default React.memo(SystemAudioMissingWarning);
